import {useLayoutEffect, useRef} from "react";
import {useFormContext} from "react-hook-form";
import projectUtils from "../../../../../../utils/project-utils.js";
const SettingsCanvas = ({setup, dataInfo}) => {
  const wrapperRef = useRef(null);
  const canvasRef = useRef(null);
  const { watch } = useFormContext();

  const upX1 = watch(`smartcaptureDriver.${setup}.model_details.smartLineUpX1`) ?? 36;
  const upX2 = watch(`smartcaptureDriver.${setup}.model_details.smartLineUpX2`) ?? 100;
  const downX1 = watch(`smartcaptureDriver.${setup}.model_details.smartLineDownX1`) ?? 0;
  const downX2 = watch(`smartcaptureDriver.${setup}.model_details.smartLineDownX2`) ?? 100;

  useLayoutEffect(() => {
    const canvas = canvasRef.current;
    const wrapper = wrapperRef.current;
    const ctx = canvas.getContext("2d");

    const reDraw = () => {
      if (!wrapper || !canvas) return;
      canvas.width = wrapper.clientWidth;
      canvas.height = wrapper.clientHeight;

      const heightCtxUp = canvas.height - (canvas.height * 0.76);
      const heightCtxDown = canvas.height - (canvas.height * 0.26);

      const calcX = (value) => {
        return Math.round((value * canvas.width) / 100 )
      }
      const calcTextX = (width, currentValue) => {
        return currentValue < 100 ? (width - 11) : (width - 17)
      }

      // Linha superior
      const lineUpX1 = calcX(upX1);
      const lineUpX2 = calcX(upX2);
      const lineUpWidth = lineUpX2 - lineUpX1;
      ctx.fillStyle = "#000";
      ctx.fillText(upX1, lineUpX1, heightCtxUp - 8);
      ctx.fillText(upX2, calcTextX(lineUpX2, upX2), heightCtxUp - 8);
      ctx.fillStyle = "#ff0000";
      ctx.fillRect(lineUpX1, heightCtxUp, lineUpWidth, 5);

      //Linha inferior
      const lineDownX1 = calcX(downX1);
      const lineDownX2 = calcX(downX2);
      const lineDownWidth = lineDownX2 - lineDownX1;
      ctx.fillStyle = "#000";
      ctx.fillText(downX1, lineDownX1, heightCtxDown - 8);
      ctx.fillText(downX2, calcTextX(lineDownX2, downX2), heightCtxDown - 8);
      ctx.fillStyle = "#ff0000";
      ctx.fillRect(lineDownX1, heightCtxDown, lineDownWidth, 5);
    }

    const observer = new ResizeObserver(() => {
      reDraw();
    })

    if (wrapper) {
      observer.observe(wrapper);
    }

    reDraw();

    return () => {
      observer.disconnect();
    };

  }, [upX1, upX2, downX1, downX2]);

  const translatedImage = (dataInfo?.latestPassageUrl && dataInfo?.archiver)
    ? projectUtils.translateImgPath(`/archiver/${dataInfo.archiver}${dataInfo.latestPassageUrl}`)
    : ""

  return(
    <div ref={wrapperRef} className="w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: translatedImage ? `url('${translatedImage}')` : 'none'
    }}>
      <canvas ref={canvasRef}></canvas>
    </div>
  )
}

export default SettingsCanvas;